<template>
  <div class="order-product">
    <p class="order-product-title">{{ cartTotalText }}</p>
    <div class="product-list">
      <!-- 购物车 -->
      <div class="product-wrap" v-if="openShoppingCart && isCart">
        <div
          class="product-item"
          v-for="(item, index) in showCartList"
          :key="item.PRODUCT_ID + item.CP_PRODUCT_ID + index"
        >
          <div class="detail-wrap" v-if="item.isProductDoubleExtra">
            <div class="left">
              <gift-icon
                class="product-icon"
                :background="getGiftBanckground(item)"
                :gifts="[showExtraIcon]"
              ></gift-icon>
            </div>
            <div class="right">
              <div class="top-bar flex-between">
                <p class="product-name">
                  {{ showExtraName }}
                </p>
                <p class="product-num">* {{ cartTotalProductExtraCoin }}</p>
              </div>
              <div class="product-price extra-gift">
                ({{ v3FirstTopUpGiveaway }})
              </div>
            </div>
          </div>
          <div class="detail-wrap" v-else-if="item.isIngameLimitedExtraCoin">
            <div class="left">
              <gift-icon
                class="product-icon"
                :background="getGiftBanckground(item)"
                :gifts="[ingameLimitedExtraCoinIcon]"
              ></gift-icon>
            </div>
            <div class="right">
              <div class="top-bar flex-between">
                <p class="product-name">
                  {{ ingameLimitedExtraCoinName }}
                </p>
                <p class="product-num">
                  * {{ cartTotalIngameLimitedExtraCoin }}
                </p>
              </div>
              <div class="product-price extra-gift">
                ({{ ingameLimitedText }})
              </div>
            </div>
          </div>
          <div class="detail-wrap" v-else-if="item.isExtra">
            <div class="left">
              <gift-icon
                class="product-icon"
                :background="getGiftBanckground(item)"
                :gifts="[showExtraIcon]"
              ></gift-icon>
            </div>
            <div class="right">
              <div class="top-bar flex-between">
                <p class="product-name">
                  {{ showExtraName }}
                </p>
                <p class="product-num">* {{ cartTotalExtraCoin }}</p>
              </div>
              <div class="product-price extra-gift">
                ({{ letter.v3ExtraGift }})
              </div>
            </div>
          </div>
          <div class="detail-wrap" v-else>
            <div class="left">
              <gift-icon
                class="product-icon"
                :background="getGiftBanckground(item)"
                :gifts="getGiftIcons(item)"
              ></gift-icon>
            </div>
            <div class="right">
              <div class="top-bar flex-between">
                <p class="product-name">
                  {{ getProductName(item) }}
                </p>
                <p class="product-num">* {{ item.quantity }}</p>
              </div>
              <div
                class="product-price"
                v-if="
                  item.amountLevel &&
                  item.amountLevel.TRANS_AMOUNT &&
                  item.amountLevel.SHOW_CURRENCY
                "
              >
                {{ item.amountLevel.TRANS_AMOUNT }}
                {{ item.amountLevel.SHOW_CURRENCY }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product-wrap" v-else>
        <!-- 直接购买 -->
        <div
          class="product-item"
          :key="curProduct.PRODUCT_ID + curProduct.CP_PRODUCT_ID"
        >
          <div class="detail-wrap">
            <div class="left">
              <gift-icon
                class="product-icon"
                :background="getGiftBanckground(curProduct)"
                :gifts="getGiftIcons(curProduct)"
              ></gift-icon>
            </div>
            <div class="right">
              <div class="top-bar flex-between">
                <p class="product-name">
                  {{ getProductName(curProduct) }}
                </p>
                <p class="product-num">* 1</p>
              </div>
              <div
                class="product-price"
                v-if="
                  curProduct.amountLevel &&
                  curProduct.amountLevel.TRANS_AMOUNT &&
                  curProduct.amountLevel.SHOW_CURRENCY
                "
              >
                {{ curProduct.amountLevel.TRANS_AMOUNT }}
                {{ curProduct.amountLevel.SHOW_CURRENCY }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="product-item"
          v-for="(item, index) in extraList"
          :key="index"
        >
          <div class="detail-wrap">
            <div class="left">
              <gift-icon
                class="product-icon"
                :background="getGiftBanckground(curProduct)"
                :gifts="[item.ICON]"
              ></gift-icon>
            </div>
            <div class="right">
              <div class="top-bar flex-between">
                <p class="product-name">
                  {{ item.NAME }}
                </p>
                <p class="product-num">* {{ item.COUNT }}</p>
              </div>
              <div class="product-price extra-gift" v-if="item.isExtra">
                ({{ letter.v3ExtraGift }})
              </div>
              <div
                class="product-price extra-gift"
                v-if="item.isProductDoubleExtra"
              >
                ({{ v3FirstTopUpGiveaway }})
              </div>
              <div
                class="product-price extra-gift"
                v-if="item.isIngameLimitedExtraCoin"
              >
                ({{ ingameLimitedText }})
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <Icon
      class="fold-icon"
      :class="{ active: !fold }"
      name="double-down"
      v-show="showFold"
      @click="handleFoldState"
    ></Icon> -->
  </div>
</template>

<script>
import productName from '@mixins/product';
import product from '@mixins/officialTopupNew/product';
import cartAddAndDetail from '@mixins/officialTopupNew/cartAddAndDetail';
import { mapState, mapGetters } from 'vuex';
import extra from '@mixins/officialTopupNew/extra';
import icon from '@mixins/officialTopupNew/icon';
import ingameLimitedExtra from '@mixins/officialTopupNew/ingameLimitedExtra';
export default {
  name: 'OrderProduct',
  mixins: [
    productName,
    product,
    cartAddAndDetail,
    extra,
    icon,
    ingameLimitedExtra
  ],
  props: {
    curProduct: {
      type: Object,
      default: () => {}
    },
    curPriceSubCoin: {
      type: Number,
      default: 0
    },
    curPriceExtraCoin: {
      type: Number,
      default: 0
    },
    curProductIngameLimitedExtraCoin: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      fold: true
    };
  },
  computed: {
    ...mapState({
      isLandscape: state => state.page.isLandscape,
      letter: state => state.letter,
      lang: state => state.lang,
      openShoppingCart: state => state.page.openShoppingCart
    }),
    ...mapGetters([
      'cartTotalProductExtraCoin',
      'cartTotalExtraCoin',
      'cartTotalIngameLimitedExtraCoin',
      'isCart',
      'ingameLimitedExtraCoinName',
      'ingameLimitedExtraCoinIcon'
    ]),
    v3FirstTopUpGiveaway() {
      return this.letter.v3FirstTopUpGiveaway?.replace?.('\n', '') || '';
    },
    cartTotalText() {
      const num =
        this.openShoppingCart && this.isCart ? this.cartTotalQuantity : 1;
      return this.letter.v3TotalNProducts.replace('${n}', num);
    },
    // showFold() {
    //   if (this.hasExtra) {
    //     return this.cartList.length >= 2;
    //   }
    //   return this.cartList.length > 2;
    // },
    hasExtra() {
      return (
        this.showExtraIcon &&
        this.cartTotalExtraCoin > 0 &&
        this.cartList?.length
      );
    },
    hasProductExtraCoin() {
      return (
        this.cartList?.reduce?.((acc, item) => {
          return acc + (Number(item?.PRODUCT_EXTRA_COIN) || 0);
        }, 0) > 0
      );
    },
    hasIngameLimitedExtraCoin() {
      return this.cartTotalIngameLimitedExtraCoin > 0 && this.cartList?.length;
    },
    showCartList() {
      let list = [...this.cartList];
      // 拷贝最后一个商品：单纯用到价格TRANS_AMOUNT来使用对应档位的背景图
      const lastTransAmount =
        this.cartList[this.cartList.length - 1]?.TRANS_AMOUNT;
      // 商品加码、首充优惠
      if (this.hasProductExtraCoin) {
        list.push({
          isProductDoubleExtra: true,
          TRANS_AMOUNT: lastTransAmount,
          PRODUCT_ID: new Date().getTime(),
          CP_PRODUCT_ID: new Date().getTime()
        });
      }
      // 游戏内限时加码赠送
      if (this.hasIngameLimitedExtraCoin) {
        list.push({
          isIngameLimitedExtraCoin: true,
          TRANS_AMOUNT: lastTransAmount,
          PRODUCT_ID: new Date().getTime(),
          CP_PRODUCT_ID: new Date().getTime()
        });
      }
      // 渠道加码
      if (this.hasExtra) {
        list.push({
          isExtra: true,
          TRANS_AMOUNT: lastTransAmount,
          PRODUCT_ID: new Date().getTime(),
          CP_PRODUCT_ID: new Date().getTime()
        });
      }
      // 移动端全部展示 PC端折叠展示前两个商品
      // if (this.isLandscape) {
      //   return list.slice(0, this.fold ? 2 : list.length);
      // }

      return list;
    },
    extraList() {
      if (!this.showExtraIcon) {
        return [];
      }
      let list = [];
      const productExtraCoin = this?.curProduct?.PRODUCT_EXTRA_COIN;
      // 商品加码、首充优惠
      if (productExtraCoin && +productExtraCoin > 0) {
        list.push({
          ID: new Date().getTime(),
          COUNT: productExtraCoin,
          NAME: this.showProductExtraCoinName,
          ICON: this.showProductExtraCoinIcon,
          TRANS_AMOUNT: productExtraCoin,
          isProductDoubleExtra: true
        });
      }
      // 游戏内限时加码赠送
      if (this.curProductIngameLimitedExtraCoin > 0) {
        list.push({
          ID: new Date().getTime(),
          COUNT: this.curProductIngameLimitedExtraCoin,
          NAME: this.ingameLimitedExtraCoinName,
          ICON: this.ingameLimitedExtraCoinIcon,
          isIngameLimitedExtraCoin: true
        });
      }
      // 渠道拆单游戏币
      if (this.curPriceSubCoin > 0) {
        list.push({
          ID: new Date().getTime(),
          COUNT: this.curPriceSubCoin,
          NAME: this.showSubCoinName,
          ICON: this.showSubCoinIcon,
          TRANS_AMOUNT: this.curPriceSubCoin,
          isExtra: true
        });
      }
      // 渠道加码
      if (this.curPriceExtraCoin > 0) {
        list.push({
          ID: new Date().getTime(),
          COUNT: this.curPriceExtraCoin,
          NAME: this.showExtraName,
          ICON: this.showExtraIcon,
          TRANS_AMOUNT: this.curPriceExtraCoin,
          isExtra: true
        });
      }
      return list;
    }
  },
  methods: {
    handleFoldState() {
      this.fold = !this.fold;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';

//商品icon
::v-deep .icon-container {
  border-radius: 10px !important;
  .icon {
    width: 40px !important;
    height: 40px !important;
  }
}

.order-product {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 16px 20px;
  background: $moduleBackgroundColor;
  font-size: 26px;
  color: #333333;

  &-title {
    font-weight: bold;
  }
}

.product-list {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding-right: 30px;
  margin-top: 20px;
  line-height: 1.5;

  .product-wrap {
    display: flex;
    overflow-x: scroll;
    scrollbar-width: none;

    .product-item {
      border-radius: 20px;
      box-sizing: border-box;
      .detail-wrap {
        display: flex;
        align-items: center;
        flex-direction: column;
        .left {
          width: 200px;
          height: 67px;
          .product-icon {
            width: 100%;
            height: 100%;
          }
        }
        .right {
          flex: 1;
          word-break: break-word;
          font-size: 20px;
          text-align: center;
          .top-bar {
            display: flex;
            flex-direction: column;
            margin-top: 10px;
            line-height: 1.5;
            .product-num {
              flex-shrink: 0;
            }
          }
          .product-price {
            display: none;
          }
        }
      }
    }
    .product-item + .product-item {
      margin-left: 20px;
    }
  }
}

.fold-icon {
  display: none;
}
.extra-wrap {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 10px 10px 40px;
  width: 100%;
  background-color: #ffffff;
  border-radius: 20px;
  .product-icon {
    flex-shrink: 0;
    width: 55px;
    margin-right: 20px;
  }
}
.extra-gift {
  color: red !important;
}

#ssr-page.landscape {
  .order-product {
    font-size: 18px;
  }

  .product-list {
    overflow: auto;
    display: block;
    height: 144px;
    padding-right: 16px;
    .product-wrap {
      display: flex;
      flex-direction: column;
      .product-item {
        .detail-wrap {
          flex-direction: row;
          .right {
            text-align: start;
            margin-left: 20px;
            font-size: 18px;
            .top-bar {
              display: flex;
              flex-direction: row;
              align-items: flex-start;
            }
            .product-price {
              display: inline-block;
              color: $themeColor;
            }
          }
        }
      }
      .product-item + .product-item {
        margin-top: 10px;
        margin-left: 0;
      }
    }
  }
  .fold-icon {
    display: block;
    cursor: pointer;
    margin: 20px auto 0;
    width: 41px;
    height: 36px;
    &.active {
      transform: rotate(180deg);
    }
  }
  .extra-wrap {
    font-size: 20px;
  }
}
</style>
